import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  ResetPasswordRequest,
  login,
  LoginRequest,
  signUp,
  SignUpRequest,
  resetPassword,
  verifySecurityCode,
  SecurityCodePayload,
  NewPasswordData,
  setNewPassword,
  UserLoginResponse,
  logout,
} from '@app/api/auth.api';
import { setUser } from '@app/store/slices/userSlice';
import { deleteToken, deleteUser, persistToken, readUserToken } from '@app/services/localStorage.service';

export interface AuthSlice {
  token: UserLoginResponse | null;
}

const initialState: AuthSlice = {
  token: readUserToken(),
};

const resetState: UserLoginResponse = {
  id: 0,
  isFirstTimeLogin: false,
  token: '',
  refreshToken: '',
};

export const doLogin = createAsyncThunk('auth/doLogin', async (loginPayload: LoginRequest) =>
  login(loginPayload).then((res) => {
    persistToken(res);
    return res;
  }),
);

export const doSignUp = createAsyncThunk('auth/doSignUp', async (signUpPayload: SignUpRequest) =>
  signUp(signUpPayload),
);

export const doResetPassword = createAsyncThunk(
  'auth/doResetPassword',
  async (resetPassPayload: ResetPasswordRequest) => resetPassword(resetPassPayload),
);

export const doVerifySecurityCode = createAsyncThunk(
  'auth/doVerifySecurityCode',
  async (securityCodePayload: SecurityCodePayload) => verifySecurityCode(securityCodePayload),
);

export const doSetNewPassword = createAsyncThunk('auth/doSetNewPassword', async (newPasswordData: NewPasswordData) =>
  setNewPassword(newPasswordData),
);

export const doLogout = createAsyncThunk('auth/doLogout', async (payload, { dispatch }) => {
  try {
    await logout();
  } catch {}
  setTimeout(() => {
    deleteUser();
    dispatch(setUser(null));
    deleteToken();
  }, 500);
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateToken: (state, action: PayloadAction<UserLoginResponse>) => {
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doLogin.fulfilled, (state, action: PayloadAction<UserLoginResponse>) => {
      state.token = action.payload;
    });
    builder.addCase(doLogout.fulfilled, (state) => {
      state.token = resetState;
    });
  },
});
export const { updateToken } = authSlice.actions;
export default authSlice.reducer;
